﻿$.fn.dxCtrlSaisiePays = function custom_dxCtrlSaisiePays(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrlsaisiepays dx-ctrl");
        this.createInstance(new cdxCtrlSaisiePays(this, option));
    }
    return this;
}

window.cdxCtrlSaisiePays = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
            mConstruit()
        }
    }

    function mConstruit() {
        container.empty();

        var ds = JSON.parse(JSON.stringify(parametre.lstIndicatifTel))
        if (option.value) {
            var itemData = parametre.lstIndicatifTel.filter(function (o) { return o.name == option.value })[0]
            if (typeof itemData == 'undefined') ds.push({
                name: option.value,
                code: ""
            })
        }

        var dxSelectPays = $("<div/>").appendTo(container).dxSelectBox({
            labelMode: 'floating',
            label: (option.label ? option.label : "Pays"),
            value: option.value,
            valueExpr: "name",
            displayExpr: "name",
            dataSource: ds,
            placeholder: "Pays...",
            dropDownOptions: { width: 300 },
            searchEnabled: true,
            searchExpr: "name",
            noDataText: "Aucun pays",
            acceptCustomValue: true,
            onFocusIn: option.onFocusIn,
            fieldTemplate: function (itemData, container) {
                if (itemData == null) {
                    $("<div/>").appendTo(container).dxTextBox({
                        placeHolder: '(Aucun pays)',
                        value: "",
                        readOnly: false,
                        onContentReady: function (e) {
                        }
                    });
                } else {
                    var $TableField = $("<table/>").appendTo(container)
                    var $TrField = $("<tr/>").appendTo($TableField)
                    var $TdField = $("<td style='width:1px;padding-right:5px;padding-top:18px;padding-left:5px;'/>").appendTo($TrField)
                    var $Img = $("<img/>").appendTo($TdField)
                    $Img.on("error", function (e) {
                        $Img.css("width", "20px")
                        $Img.attr("src", parametre.urldispatch + '/img/icone_office/signal_flag_checkered.png')
                    })
                    if (itemData.code != null) $Img.attr("src", "https://flagcdn.com/w20/" + itemData.code.toLowerCase() + ".png")
                    //$("<img src='https://flagcdn.com/16x12/" + itemData.code.toLowerCase() + ".png' " +
                    //"srcset='https://flagcdn.com/32x24/" + itemData.code.toLowerCase() + ".png 2x,https://flagcdn.com/48x36/" + itemData.code.toLowerCase() + ".png 3x' width:='16' height='12'/>").appendTo($TdField)
                    var $TdField = $("<td style='width:100%'></td>").appendTo($TrField)
                    $("<div/>").appendTo($TdField).dxTextBox({
                        value: itemData.name,
                        readOnly: false,
                        onContentReady: function (e) {
                            //e.component.element().find("input").css("padding", "0")
                        }
                    });
                }
            },
            itemTemplate: function (itemData, itemIndex, itemElement) {
                itemElement.css("padding", "5px")
                var $Img = $("<img/>").appendTo(itemElement)
                $Img.on("error", function (e) {
                    $Img.css("width", "20px")
                    $Img.attr("src", parametre.urldispatch + '/img/icone_office/signal_flag_checkered.png')
                })
                if (itemData.code != null) $Img.attr("src", "https://flagcdn.com/w20/" + itemData.code.toLowerCase() + ".png")
                //$("<img src='https://flagcdn.com/16x12/" + itemData.code.toLowerCase() + ".png' " +
                //"srcset='https://flagcdn.com/32x24/" + itemData.code.toLowerCase() + ".png 2x,https://flagcdn.com/48x36/" + itemData.code.toLowerCase() + ".png 3x' width:='16' height='12'/>").appendTo(itemElement)
                $("<span style='padding-left:5px;'>" + itemData.name + "</span>").appendTo(itemElement)
            },
            onCustomItemCreating(data) {
                if (!data.text) {
                    data.customItem = null;
                    return;
                } else {
                    const newItem = {
                        name: data.text,
                        code: "",
                    };
                    ds.push(newItem)
                    window.setTimeout(function () {
                        dxSelectPays.option({ "dataSource": ds, "value": data.text })
                    }, 0)
                    data.customItem = null;
                    return;
                }
            },
            onValueChanged: function (e) {
                var val = ds.filter(function (o) { return o.name == e.value })[0]    
                if (!val) val = {name:e.value,code:""}
                option.onValueChanged({ value: val })
            },
            onContentReady:option.onContentReady
        }).dxSelectBox("instance")
    }

    this.element = function () { return container }
    this.component = function () { return dx }

    mConstruit();
}